import { IFormController } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import GlobalSpinnerService from '../../common/services/spinner/global-spinner.service';
import { OpenMasterpassCardAddOtpAction } from './masterpass-card-add-otp-dialog.action';

/* @ngInject */
export default class CardAddDialogController implements ActionHandler {

  protected approve: () => any;
  public smsCode: string;
  public valid: boolean = true;
  public time: string;
  public isReqSend: boolean;
  public title: string;
  public message: string;
  public resendDisabled: boolean = true;
  protected dialogElement;
  protected dialogOptions;

  protected onSuccess: (code:string, stopTimer:any, isReqSent: any) => any;
  protected onResend:() => any;

  private timer: any = null;
  private smsForm: IFormController;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $interval,
    private $scope,
    private $translate,
    protected globalSpinner: GlobalSpinnerService
  ) {
    this.actionDispatcher.register(this);
    this.$translate('payment.masterpass.otp.title').then(value => {
      this.title = value;
    });
    this.$translate('payment.masterpass.otp.message').then(value => {
      this.message = value;
    });
  }

 
  public $postLink() {
    this.dialogElement = this.$element.find('#bank-confirmation').remodal();
    this.actionDispatcher.register(this);
    angular.element(() => {
      this.smsForm = this.$scope.smsForm;
    });
  }
  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenMasterpassCardAddOtpAction) {
      this.reset();
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenMasterpassCardAddOtpAction) {
    this.onSuccess = action.onApprove;
    this.onResend = action.onResend;
    if(action.otpType) {
      this.$translate('payment.masterpass.otp.' + action.otpType.toLowerCase() + '.title').then(value => {
        this.title = value;
      });
      this.$translate('payment.masterpass.otp.' + action.otpType.toLowerCase() + '.message').then(value => {
        this.message = value;
      });
    }
    
    this.openDialog();
    this.startTimer();
  }

  protected onApprove() {
    if (!this.validate()) {
      return;
    }
    this.isReqSend = true;
    this.onSuccess(this.smsCode, this.onStopTimer.bind(this), this.stopReqSent.bind(this));
  }

  public stopReqSent(){
    this.isReqSend = false;
    this.resetSmsCode();
  }

  private resetSmsCode() {
    if (this.smsForm) {
      this.smsCode = undefined;
      this.smsForm.$setPristine();
      this.smsForm.$setUntouched();
    }
  }

  protected onResendCode() {
    this.resendDisabled = true;
    this.resetTimer();
    this.onResend();
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
    this.isReqSend = false;
  }

  protected reset() {
    this.resetTimer();
    this.resetSmsCode();
    this.isReqSend = false;
    this.resendDisabled = true;
  }

  protected resetTimer() {
    // Cancel the Timer.
    if (angular.isDefined(this.timer)) {
      this.$interval.cancel(this.timer);
    }

    this.time = '03:00';
  }

  private validate(): boolean {
    this.valid = this.smsCode && this.smsCode.trim().length > 0;
    return this.valid;
  }

  private startTimer() {
    const countDownDate = new Date().getTime() + 3 * 60 * 1000;
    this.timer = this.$interval(() => {
      // Get todays date and time
      const now = new Date().getTime();

      // Find the distance between now an the count down date
      const distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // If the count down is over, write some text
      if (distance < 0) {
        this.resendDisabled = false;
        return;
      }

      // Output the result
      this.time = '0' + minutes + ':' + (seconds > 9 ? seconds : '0' + seconds);
    }, 1000);
  }

  public onStopTimer() {
    this.close();
    this.resetTimer();
  }


}



// WEBPACK FOOTER //
// ./src/app/buy/masterpass-card-add-otp-dialog/masterpass-card-add-otp-dialog.controller.ts